export default __webpack_public_path__ + "static/brush-yellow-spark-right-11480b9ffdff4e62081b913d588322d1.png";